import { sendRequest } from '../../config';

export interface getFollowUpParams {
    //campos obligatorios
    cpais: string;

    //campos opcionales
    nlocaliza?: string;
    ccedaseg?: string;
    xdetalle?: string;
    xnclave?: string;
    cdoctor?: string;
    cclinica?: string;
    cplan?: string;
    cciaseg?: string;
}

export interface dataGetFollowUp {
    nlocaliza?: string;
    iseg?: string;
    cconsec?: string;
    u_version?: string;
    ccedaseg?: string;
    itipo?: string;
    xdetalle?: string;
    xnclave?: string;
    cdoctor?: string;
    cclinica?: string;
    coperador?: string;
    fecha?: string;
    hora?: string;
    fproxcita?: string;
    horaproxcita?: string;
    status?: string;
    ncana?: string;
    nrecla?: string;
    xdet?: string;
    cciudad?: string;
    cestado?: string;
    cplan?: string;
    cciaseg?: string;
    nrelacion?: string;
    cetiqueta?: string;
    icontacto?: string;
    ihojavida?: string;
    iseginmediato?: string;
    fingreso?: string;
    cusuario?: string;
    ccategoria?: string;
    cusuarioauto?: string;
    ccategoriaauto?: string;
    fultmod?: string;
    cusuariomod?: string;
    ccategoriamod?: string;

    description?: string;
}

export const getFollowUp = async (params: getFollowUpParams): Promise<dataGetFollowUp[]> => {

    const ENDPOINT = 'wslocalizador/getFollowUp';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};

